import { CSSProperties } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/en';
import { useI18n } from '../../shared/i18n/i18n-context';

interface DatePickerComponentProps {
    label: string;
    value: Dayjs | null;
    onChange: (newValue: Dayjs | null) => void;
    styles?: CSSProperties;
}

export default function DatePickerComponent({ label, value, onChange, styles }: DatePickerComponentProps) {
    const { language } = useI18n();
    const adapterLocale = language === 'en' ? 'en' : 'pt-br';
    dayjs.locale(adapterLocale);

    return (
        <LocalizationProvider 
            dateAdapter={AdapterDayjs}
            adapterLocale={adapterLocale}>
            <DatePicker
                className='date-picker'
                label={label}
                value={value}
                onChange={onChange}
                format={language === 'en' ? 'MM/DD/YYYY' : 'DD/MM/YYYY'}
                sx={styles}
            />
        </LocalizationProvider>
    );
}
